import Breadcrumbs from "../../../components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Container, Row } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import configure from "configure"
import Loader from "pages/Separate/Loader"

const ViewPortfolio = () => {
  const [description, setdescription] = useState(false)
  const [Loading, setLoading] = useState(false)
  const [ApiData, setApiData] = useState({})
  const { id } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    fetchportfolio()
  }, [])

  const fetchportfolio = async () => {
    setLoading(true)
    axios
      .get(`${configure.nodeApi}/portfolio/${id}`)
      .then(res => {
        setLoading(false)
        setApiData(res?.data?.portfolio)
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  return (
    <div className="page-content mb-3">
      {Loading && <Loader />}
      <Container fluid>
        <Breadcrumbs title="Dashboard" breadcrumbItem="View Portfolio" />
        <Row className="bg-white py-3">
          <div className="text-end">
            <button
              type="button"
              onClick={() => navigate(`${configure.appUrl}portfolio`)}
              className="btn btn-red btn-label ms-2"
            >
              <i className="dripicons-cross me-2 label-icon" /> Cancel
            </button>
          </div>
          <h2 className="text-center text-purple fw-bold mb-3">
            Our Valuable Projects
          </h2>
          <h4 className="text-center mb-4">
            How We Help Your Business Succeed
          </h4>
          <div className="row my-3">
            {ApiData?.caseStudies?.map((item, i) => {
              const project_images = item?.project_image
                ? JSON.parse(item.project_image)
                : []
              return (
                <div className="col-xl-4 mb-3 mb-xl-0" key={i}
                  onClick={() => {
                    navigate(`${configure.appUrl}view-case-study/${item.id}`)
                  }}>
                  <div className="case-study-cards" >
                    <img src={
                      project_images
                        ? `${configure.nodeImgApi}/${project_images[0]}`
                        : null
                    }
                      style={{ height: "250px", objectFit: "cover" }}
                      className="w-100 object-fit-cover" />
                    <h5 className="text-purple fw-bolder p-3 pb-0">{item?.project_name}</h5>
                    <div className="d-flex justify-content-between p-2 pt-0 pb-0">
                      <div className="fw-bolder text-dark px-2 pb-0">
                        <h6 className="fst-italic fw-medium">{item?.technologies?.map((obj, i, arr) => (
                          <span className="" key={i}>
                            {obj}{i < arr.length - 1 ? ', ' : ''}
                          </span>
                        ))}</h6>
                      </div>
                    </div>
                    <h6 className="p-2 px-3 lh-base" dangerouslySetInnerHTML={{ __html: item?.project_overview?.slice(0, 150) }} />
                  </div>
                </div>
              )
            })}
          </div>
        </Row>

      </Container>
    </div >
  )
}

export default ViewPortfolio
